export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';
